import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { LocaleService, TranslationService, Language, DefaultLocale, Currency } from 'angular-l10n';
import { Direction } from '@angular/cdk/bidi';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.css']
})
export class LanguageComponent implements OnInit {

  countryMenuItems: any[] = [
    { text: 'Australia', language: 'en', country: 'AU', currency: 'AUD', numberingSystem: 'latn' },
    { text: 'United States', language: 'en', country: 'US', currency: 'USD', numberingSystem: 'latn' },
    { text: 'United Kingdom', language: 'en', country: 'GB', currency: 'GBP', numberingSystem: 'latn' },
    { text: 'Deutschland', language: 'de', country: 'DE', currency: 'EUR', numberingSystem: 'latn' },
    { text: 'Bahasa Indonesia', language: 'id', country: 'ID', currency: 'IDR', numberingSystem: 'latn' },
    { text: 'Italia', language: 'it', country: 'IT', currency: 'EUR', numberingSystem: 'latn' },
    { text: 'हिंदी', language: 'hi', country: 'HI', currency: 'IND', numberingSystem: 'latn' },
    { text: 'المملكة العربية السعودية', language: 'ar', country: 'SA', currency: 'SAR', numberingSystem: 'arab' },
    { text: 'المملكة العربية السعودية - Arabic', language: 'ar', country: 'SA', currency: 'SAR', numberingSystem: 'latn' },
    { text: 'New Zealand', language: 'en', country: 'NZ', currency: 'NZD', numberingSystem: 'latn' },
  ];

  dir: Direction;

  @Output() direction: EventEmitter<any> = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<LanguageComponent>, public locale: LocaleService, public translation: TranslationService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

    // Function to define Language, Locale and currency
  setLocale(language: string, country: string, currency: string, numberingSystem: string): void {
    // console.log(language, country, currency, numberingSystem);
    this.locale.setDefaultLocale(language, country, '', numberingSystem);
    this.locale.setCurrentCurrency(currency);
    this.dir = this.getLanguageDirection(language);
    // console.log(this.dir === 'ltr' ? 'ltr' : 'rtl');

    this.direction.emit(this.dir === 'ltr' ? 'ltr' : 'rtl');

  }

  getLanguageDirection(language?: string): Direction {
    return this.locale.getLanguageDirection(language) as Direction;
  }

  get currentCountry(): string {
    return this.locale.getCurrentCountry();
  }

  get currentNumberingSystem(): string {
    return this.locale.getCurrentNumberingSystem();
  }

}
